import { render, staticRenderFns } from "./Doc_Treat.vue?vue&type=template&id=476ba038&scoped=true&"
import script from "./Doc_Treat.vue?vue&type=script&lang=js&"
export * from "./Doc_Treat.vue?vue&type=script&lang=js&"
import style0 from "./Doc_Treat.vue?vue&type=style&index=0&id=476ba038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ba038",
  null
  
)

export default component.exports